'use strict';

import type { IndDependent } from '../../Entities/Ind/IndDependent';
import { EntityCollection } from '../EntityCollection';

export class IndDependentCollection extends EntityCollection<IndDependent> {}
